import { getElementById } from "../util/Utils";
import { any } from "../util/Reductions";

const ToggleNames = [
  "DUMMY",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL_EXPERIMENT",
  "HEUREKA_663_CLUSTER_REDUZIERUNG_FIRST_LEVEL_TRACKING",
  "HEUREKA_1032_NEXT_BEST_ACTION",
  "HEUREKA_1032_NEXT_BEST_ACTION_E3049",
  "HEUREKA_1047_STICKY_SIDEBAR",
  "HEUREKA_1047_STICKY_SIDEBAR_EXPERIMENT_E3023",
  "HEUREKA_1072_KRACHERTAGE_POSITION1",
  "HEUREKA_1142_PERSONALIZATION_SAVE_SIZES",
  "HEUREKA_1142_PERSONALIZATION_SAVE_SIZES_E3095",
  "HEUREKA_1153_CHIPS_WITH_PRICE_RANGES",
  "HEUREKA_1153_CHIPS_WITH_PRICE_RANGES_E3131",
  "HEUREKA_1155_DIMENSIONS_WITHOUT_SLIDER",
  "HEUREKA_1155_DIMENSIONS_WITHOUT_SLIDER_E3130",
  "HEUREKA_1227_IGNORE_MERGEONPI_ATTR_ON_LOAD_FAILURE",
  "HEUREKA_1258_NEW_FILTER_VISIBILITIES_LOGIC",
  "HEUREKA_1258_NEW_FILTER_VISIBILITIES_LOGIC_E3163",
  "HEUREKA_1303_SVELTE_SLIDER_COMPONENT",
  "HEUREKA_1346_SUBMIT_PENDING_DELAYED_ACTIONS_ON_SHEET_CLOSING",
] as const;

export type ToggleName = (typeof ToggleNames)[number];
export type ToggleStates = Record<ToggleName, boolean>;

let toggles: ToggleStates;

function asBoolean(value?: string): boolean {
  return "true" === value;
}

export function initToggles() {
  const data = getElementById("leafcutter_toggles")?.dataset;
  const state = data
    ? (toggleName: ToggleName) => asBoolean(data[toggleName] || data[toggleName.toLowerCase()])
    : () => false;
  toggles = ToggleNames.reduce((htmlToggles, toggleName) => {
    htmlToggles[toggleName] = state(toggleName);
    return htmlToggles;
  }, {} as Partial<ToggleStates>) as ToggleStates;
}

/**
 *
 */
export function updateToggle(toggle: ToggleName, state: boolean) {
  toggles[toggle] = state;
}

export function isInactive(toggle: ToggleName) {
  return !isActive(toggle);
}

export function isActive(toggle: ToggleName) {
  return toggles[toggle];
}

export function isAnyActive(...toggles: ToggleName[]) {
  return toggles.map(isActive).reduce(any, false);
}
